export enum ValoremPublishStatusEnum {
  Success = 'Success',
  NotPublished = 'NOT PUBLISHED'
}
